module.exports = __webpack_public_path__ + "img/background053.731df4b8.jpg";